// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  BuildOutlined,
  CalendarOutlined,
  CustomerServiceOutlined,
  FileTextOutlined,
  MessageOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  AppstoreAddOutlined,
  DashboardOutlined,
  FileOutlined,
  AreaChartOutlined,
  ProfileOutlined,
  AccountBookOutlined,
  PlusCircleOutlined,
  ClockCircleOutlined,
} from '@ant-design/icons';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  BuildOutlined,
  CalendarOutlined,
  CustomerServiceOutlined,
  MessageOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  AppstoreAddOutlined,
  FileTextOutlined,
  DashboardOutlined,
  FileOutlined,
  AreaChartOutlined,
  ProfileOutlined,
  AccountBookOutlined,
  PlusCircleOutlined,
};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const applications: NavItemType = {
  id: 'group-applications',
  title: '',
  icon: icons.AppstoreAddOutlined,
  type: 'group',
  children: [
    {
      id: 'Dashboard',
      title: <FormattedMessage id='dashboard' />,
      type: 'item',
      url: '/dashboard',
      icon: DashboardOutlined,
      target: false,
    },
    {
      id: 'List Accounts',
      title: <FormattedMessage id='accounts' />,
      type: 'item',
      url: '/accounts',
      icon: AccountBookOutlined,
      target: false,
    },
    {
      id: 'History',
      title: <FormattedMessage id='log' />,
      type: 'item',
      url: '/log',
      icon: ClockCircleOutlined,
      target: false,
    },
  ],
};

export default applications;
